import {
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet'
import { Skeleton } from '@/components/ui/skeleton'

export const DeleteCompanySheetFallback = () => {
  return (
    <>
      <SheetHeader>
        <SheetTitle>Delete company</SheetTitle>
        <SheetDescription>
          <Skeleton className="h-3.5 w-[220px]" />
        </SheetDescription>
      </SheetHeader>
      <div className="px-4 overflow-y-auto w-full pb-2">
        <Skeleton className="h-3.5 w-[160px] mb-2" />
        <div className="grid gap-2 mb-6">
          <Skeleton className="h-11 w-full" />
          <Skeleton className="h-11 w-full" />
          <Skeleton className="h-11 w-full" />
          <Skeleton className="h-11 w-full" />
          <Skeleton className="h-11 w-full" />
          <Skeleton className="h-11 w-full" />
        </div>
        <Skeleton className="h-3.5 w-[260px] mb-2" />
        <Skeleton className="h-16 w-full" />
      </div>
      <SheetFooter className="sticky">
        <Skeleton className="h-9 w-full" />
      </SheetFooter>
    </>
  )
}
